import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import InfoTooltip from 'components/consumer/InfoTooltip';
const BrandTooltip = t0 => {
  const $ = _c(22);
  let children;
  let closeButtonClassName;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let title;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      closeButtonClassName,
      hideIconOnOpenMobile: t1,
      iconClassName: t2,
      openOnHover: t3,
      showCloseButton: t4,
      title,
      variant,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = closeButtonClassName;
    $[3] = otherProps;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = title;
    $[9] = variant;
  } else {
    children = $[1];
    closeButtonClassName = $[2];
    otherProps = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    title = $[8];
    variant = $[9];
  }
  const hideIconOnOpenMobile = t1 === undefined ? false : t1;
  const iconClassName = t2 === undefined ? "" : t2;
  const openOnHover = t3 === undefined ? false : t3;
  const showCloseButton = t4 === undefined ? true : t4;
  let t5;
  if ($[10] !== children) {
    t5 = !!children && <div className="text-xs m-0 normal-case">{children}</div>;
    $[10] = children;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== closeButtonClassName || $[13] !== hideIconOnOpenMobile || $[14] !== iconClassName || $[15] !== openOnHover || $[16] !== otherProps || $[17] !== showCloseButton || $[18] !== t5 || $[19] !== title || $[20] !== variant) {
    t6 = <InfoTooltip closeButtonClassName={closeButtonClassName} iconClassName={iconClassName} modifier="brand-fade" openOnHover={openOnHover} parentTitle={title} showCloseButton={showCloseButton} variant={variant} withArrow={true} hideIconOnOpenMobile={hideIconOnOpenMobile} {...otherProps}>{t5}</InfoTooltip>;
    $[12] = closeButtonClassName;
    $[13] = hideIconOnOpenMobile;
    $[14] = iconClassName;
    $[15] = openOnHover;
    $[16] = otherProps;
    $[17] = showCloseButton;
    $[18] = t5;
    $[19] = title;
    $[20] = variant;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
BrandTooltip.propTypes = {
  children: PropTypes.node,
  closeButtonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  openOnHover: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  title: PropTypes.node,
  variant: PropTypes.string
};
export default BrandTooltip;